// extracted by mini-css-extract-plugin
export default {"carousel":"Gca","ingredient":"Hca","swiper-pagination-bullet":"Ica","swiper-pagination-bullet-active":"Jca","swiper_carousel":"Kca","swiper_pagination":"Lca","arrows":"Mca","arrow_navigation":"Nca"};
    if(module.hot) {
      // 1743628931596
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  